import React from 'react';
import { Button } from './Button';
import { useInViewAnimation } from '../hooks/useInViewAnimation';

export function PricingSection() {
  const { ref, isInView } = useInViewAnimation();

  return (
    <section ref={ref} className="w-full py-12 px-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
        {/* Card 1 (Dark + violet gradient) — Long-Term Engineering Partnership */}
        <div
          className={`relative overflow-hidden bg-gradient-to-br from-[#051A24] via-[#1E1B4B] to-[#4C1D95] rounded-[40px] pl-10 pr-10 md:pr-16 pt-10 pb-10 shadow-[0_20px_60px_rgba(76,29,149,0.25)] flex flex-col justify-between ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
          style={{ animationDelay: '0.1s' }}
        >
          {/* ambient glow */}
          <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-[#7C3AED]/30 blur-3xl pointer-events-none animate-pulse-glow" />

          <div className="relative">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#C4B5FD] mb-3">[01] Retainer</div>
            <h3 className="text-[22px] font-medium text-[#F6FCFF] mb-4">Long-Term Engineering Partnership</h3>
            <p className="text-[#E0EBF0] mb-8 leading-relaxed">
              A dedicated senior team across AI, product,<br />
              cloud and DevOps &mdash; embedded with yours.
            </p>
          </div>

          <div className="relative">
            <div className="mb-8">
              <span className="text-2xl text-[#F6FCFF] block mb-1">Monthly retainer</span>
              <span className="text-[#C4B5FD] text-sm font-mono">$ scoped_per_engagement</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <Button to="/contact" variant="secondary" className="!bg-white !text-[#051A24]">
                Book a Discovery Call
              </Button>
              <Button to="/services" variant="primary" className="!bg-transparent !bg-none !text-white border border-[#7C3AED] !shadow-none hover:!shadow-[0_8px_28px_rgba(124,58,237,0.45)]">
                How we work
              </Button>
            </div>
          </div>
        </div>

        {/* Card 2 (Light) — Fixed-Scope Project */}
        <div
          className={`relative overflow-hidden bg-white rounded-[40px] pl-10 pr-10 md:pr-16 pt-10 pb-10 shadow-[0_20px_60px_rgba(5,26,36,0.06)] border border-[#7C3AED]/10 flex flex-col justify-between ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
          style={{ animationDelay: '0.2s' }}
        >
          <div className="absolute -bottom-24 -left-24 w-64 h-64 rounded-full bg-[#7C3AED]/10 blur-3xl pointer-events-none" />

          <div className="relative">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#4C1D95] mb-3">[02] Project</div>
            <h3 className="text-[22px] font-medium text-[#0D212C] mb-4">Fixed-Scope Enterprise Build</h3>
            <p className="text-[#273C46] mb-8 leading-relaxed">
              Defined outcome, defined timeline.<br />
              Delivered end-to-end with the same senior team.
            </p>
          </div>

          <div className="relative">
            <div className="mb-8">
              <span className="text-2xl text-[#0D212C] block mb-1">Custom quote</span>
              <span className="text-[#4C1D95] text-sm font-mono">$ after_discovery</span>
            </div>
            <div className="flex">
              <Button to="/contact" variant="primary">
                Request a Proposal
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
